module.exports = __webpack_public_path__ + "static/media/voga3.2956c48f.jpg";